// DS: i9.9
import React from 'react';
import IconWrap from '../IconWrap';
const Cart = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M10 19a1 1 0 110 2 1 1 0 010-2zm7 0a1 1 0 110 2 1 1 0 010-2zM6.007 3c.446 0 .828.301.951.714L7.484 6h12.369a1 1 0 01.99 1.136l-.963 7a1 1 0 01-.99.864H9.563l.231 1H18a1 1 0 010 2H9a1 1 0 01-.998-.94 1.019 1.019 0 01-.054-.168L5.202 5H4a1 1 0 110-2h2.007z"
    })));
};
Cart.displayName = 'Cart';
export default Cart;

//# sourceMappingURL=Cart.js.map